<template>
  <b-form-group label="Angka Cap" description="Angka Cap Harus 3 digit (contohnya: 750)">
    <b-row no-gutters>
      <b-col>
        <b-input-group> 
          <b-form-input
            v-model="input.pointCapEmas"
            :value="input.pointCapEmas"
            maxlength="3"
            name="angkaCap"
            type="text"
            @keypress="onKeyPressNumberOnly"
            @input="onInputNumberLimit"
          />
        </b-input-group>

      </b-col>

      <b-col cols="3" class="ml-2" :hidden="$companyId !== 'PGI'">
        <!-- Konten jika diperlukan -->
      </b-col>
    </b-row>
  </b-form-group>
</template>

<script>
export default {
  props: {
    input: { required: true },
    cap: { required: true },
  },
  methods: {
    onKeyPressNumberOnly(e) {
      const char = String.fromCharCode(e.which);
      if (!/[0-9]/.test(char)) {
        e.preventDefault(); // Cegah huruf/karakter non-angka
      }
    },
    onInputNumberLimit(e) {
      const raw = e.target.value.replace(/\D/g, '').slice(0, 3);
      this.input.pointCapEmas = raw;
    },
  },
}
</script>
